import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

@Directive({
  selector: '[tooltip]'
})

export class TooltipDirective implements OnDestroy {
  constructor(private _elementRef: ElementRef, private translocoService: TranslocoService) {
  }

  @Input() tooltipContent: string = '';
  @Input() delay: number = 300;
  @Input() tooltipDynamicContent: string = '';
  @Input() tooltipInjectOnElement = false;
  public myPopup;
  public timer;

  ngOnDestroy(): void {
    if (this.myPopup) { this.myPopup.remove() }
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.timer = setTimeout(() => {
      let x = this._elementRef.nativeElement.getBoundingClientRect().left + this._elementRef.nativeElement.offsetWidth / 2;
      let y = this._elementRef.nativeElement.getBoundingClientRect().top + this._elementRef.nativeElement.offsetHeight + 6;
      this.createTooltipPopup(x, y);
    }, this.delay)
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.timer) clearTimeout(this.timer);
    if (this.myPopup) { this.myPopup.remove() }
  }

  private createTooltipPopup(x: number, y: number) {
    let mainToolTipContainer = document.createElement('div');
    mainToolTipContainer.setAttribute("class", "tooltip-main-container");
    let popupContentContainer = document.createElement('div');
    popupContentContainer.setAttribute("class", "tooltip-content-container");
    let spanContainer = document.createElement('span');
    spanContainer.setAttribute("class", "tooltip-content-span");
    mainToolTipContainer.appendChild(popupContentContainer);
    popupContentContainer.appendChild(spanContainer);
    mainToolTipContainer.style.top = y.toString() + "px";
    mainToolTipContainer.style.left = x.toString() + "px";
    if (this.tooltipDynamicContent !== '') {
      spanContainer.innerText = this.translocoService.translateObject(this.tooltipContent, { key: this.tooltipDynamicContent });
    }
    else {
      spanContainer.innerText = this.translocoService.translateObject(this.tooltipContent);
    }
    if (this.tooltipInjectOnElement) {
      this._elementRef.nativeElement.appendChild(mainToolTipContainer);
    }
    else {
      document.body.appendChild(mainToolTipContainer);
    }
    this.myPopup = mainToolTipContainer;
    this.handleOverflow(mainToolTipContainer);
  }
  public handleOverflow(tooltipElement) {

    let boundingRect = tooltipElement.getBoundingClientRect();
    tooltipElement.style.display = "block";
    tooltipElement.style.width = "max-content";
    if (parseInt(boundingRect.right + boundingRect.width) > (window.innerWidth - (OffsetValues.appPadding + OffsetValues.bodyPadding))) {
      //right overflow;  
      const left = parseFloat(tooltipElement.style.left) - ((boundingRect.right - window.innerWidth) + (tooltipElement.offsetWidth - OffsetValues.OffsetPadding)) - OffsetValues.appPadding;
      const elementLeft = (left > OffsetValues.appPadding ? left : OffsetValues.appPadding);
      tooltipElement.style.left = elementLeft + "px";
      tooltipElement.style.width = "auto";
    }

  }
}
export enum OffsetValues {
  OffsetPadding = 30,
  appPadding = 10,
  bodyPadding = 30
}